import { Group } from '@core/models/group.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class GroupEntityService extends EntityCollectionServiceBase<Group> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('MemberGroup', serviceElementsFactory);
  }
}
